export const m={
  home:'首页',
  msg:'信息',
  zx:'资讯',
  active:'活动',
  searchText:'搜索内容',
  indexRelease:'发布信息',
  more:'加载更多',
  moreTips:'没有更多数据',
  indexErrands:'发布跑腿',
  indexSend:'去发布',
  indexVersion:'跑腿',
  indexAgent:'代购',
  indexRequired:'需认证',
  indexMyRelease:'我的发布',
  indexComment:'我的评价',
  indexShop:'商城',
  indexContact:'联系客服',
  indexFeedback:'意见反馈',
  indexPolicy:'隐私政策',
  indexHelp:'帮助中心',
  indexLogin:'登录',
  indexReg:'注册',
  BackIndex:'返回首页',
  indexNeeds:'我的需求',
  indexMyHome:'我的主页',
  indexScore:'我的积分',
  indexCoins:'我的金币',
  indexSet:'账号设置',
  indexOut:'退出登录',
  indexPersonal:'个人认证',
  indexEnterprise:'企业认证',
  indexAuth:'去认证',
  indexReviewed:'待审核',
  indexApproved:'审核通过',
  indexAudit:'审核未通过',
  Smslogin:'短信登录',
  Pwdlogin:'密码登录',
  SmsloginTips:'未注册的手机号登录将自动注册',
  hotPhone:'热线电话',
  loginPhone:'请输入手机号码',
  loginCode:'请输入短信验证码',
  loginStatus:'记住登录状态',
  loginForget:'忘记密码',
  loginText:'使用已注册的账号登录',
  inputPwd:'请输入密码',
  otherWay:'其它登录方式',
  loginAgreen:'注册即代表我已阅读并同意',
  agreenName:'用户协议及隐私政策',
  yzPhone:'验证手机号码',
  setNewPwd:'设置新密码',
  setNewSuccess:'密码重置成功',
  setPwdTips:'请设置6-20位登录密码',
  setAgainPwd:'请再次输入新的登录密码',
  setHrefTips:'秒后自动跳转至登录',
  nextText:'下一步',
  sureText:'确定',
  wechartTitle:'微信扫码登录',
  bindTitle:'绑定手机号',
  submitTitle:'提交',
  myCollect:'收藏关注',
  myMsg:'我的消息',
  myRz:'账号认证',
  collectText:'收藏',
  followText:'关注',
  scoreText:'积分',
  coinText:'金币',
  signInText:'签到',
  signInOverText:'已签到',
  allText:'全部',
  quotedText:'待报价',
  completedText:'待完成',
  confirmedText:'待确认',
  evaluatedText:'待评价',
  cancelledText:'已取消',
  typeText:'类型',
  endTimeText:'截止时间',
  demandText:'需求详情',
  noDataText:'暂无数据',
  lookText:'查看详情',
  fsText:'粉丝',
  editZlText:'编辑资料',
  cancelGzText:'取消关注',
  editText:'编辑',
  delText:'删除',
  fbyText:'发布于',
  msgDetailText:'信息详情',
  shHomeText:'商户主页',
  shDetailText:'商户详情',
  rzMsgText:'认证信息',
  zhCommentText:'综合评价',
  contactNumText:'联系电话',
  contactAdrText:'联系地址',
  ytgText:'已通过商户认证',
  norzText:'未认证',
  nothingText:'无',
  shopMsgText:'店铺信息',
  shopNoMsgText:'暂无店铺信息',
  BackPrevText:'返回上一页',
  noCommentText:'暂无评价',
  shrzzlText:'商户认证资料',
  qyNameText:'企业名称',
  frNameText:'法人姓名',
  yyzzText:'营业执照',
  bidInfoText:'中标信息',
  runFreeText:'跑腿费',
  remarkMsgText:'备注信息',
  commentRunText:'评价跑腿员',
  rwSubmitText:'任务提交详情',
  sureFinishText:'确认完成',
  rwStatusText:'任务状态',
  bjListText:'报价列表',
  seeText:'查看',
  noBjText:'未中标报价',
  rwTypeText:'任务类型',
  rwNameText:'任务名称',
  ysMoneyText:'预算金额',
  sendTimeText:'发布时间',
  remidSmText:'需求说明',
  runNameText:'跑腿员名称',
  bjbzText:'报价备注',
  operationText:'操作',
  chooseText:'选择',
  ptjbText:'跑腿费（金币）',
  editShText:'编辑商户资料',
  editShTips:'修改商户资料提交后需由平台审核通过后对外生效显示',
  bussinessName:'商户名称：',
  bussinessNameInput:'请输入商户名称',
  bussinessAddress:'商户地址：',
  bussinessAddressInput:'请输入商户地址',
  bussinessPhone:'商户电话：',
  bussinessPhoneInput:'请输入商户电话',
  bussinessPic:'图文介绍：',
  bussinessInput:'请输入',
  bussinessText:'已输入',
  uploadText:'上传图片',
  shareText:'分享至',
  collectedText:'已收藏',
  shMessageText:'商户信息',
  nozwText:'暂无',
  LookshText:'查看商户主页',
  postCommentText:'发布评论',
  postCommentTips:'文明上网理性发言，请遵守评论服务协议',
  noLogin:'未登录',
  noLoginTips:'登录后可以发表评论',
  ljLogin:'立即登录',
  expression:'表情',
  releaseText:'发布',
  allCommentText:'全部评论',
  fabulousText:'赞',
  replayText:'回复',
  stowreplyText:'收起回复',
  zwPlText:'暂无评论',
  tjText:'推荐',
  replyCommentsText:'回复评论',
  allZxText:'全部资讯',
  zxDetailText:'资讯详情',
  hotTjText:'热门推荐',
  ybActiveText:'一般活动',
  jggActiveText:'九宫格抽奖',
  activeYcyText:'已参与',
  activeYfxText:'已分享',
  activeFwlText:'访问量',
  winningList:'中奖榜单',
  myPrize:'我的奖品',
  myPrizeText:'抽中了',
  activeInfo:'活动介绍',
  activeAllInfo:'全部活动',
  activeDzp:'大转盘抽奖',
  oneText:'一等奖',
  twoText:'二等奖',
  threeText:'三等奖',
  selectText:'评选活动',
  totalVotesText:'总票数',
  sjNumText:'商家数',
  numberVoteText:'号',
  tpVoteText:'投票',
  pVoteText:'票',
  dlqText:'待领取',
  ywcText:'已完成',
  editBussinessTips:'商户资料更改审核中，请耐心等待。',
  editBussinessTipsSuccess:'商户资料已审核通过',
  reSubmitTips:'重新提交',
  help:'帮助中心分类',
  zdTitle:'中大纺织城',
  zdTips:'个性推荐，便捷切换 随心享受精彩资讯',
  zdBanTitle:'版',
  locationChoose:'按省份选择',
  locationChooseInput:'请选择省份',
  locationSearch:'直接搜索',
  locationSearchText:'搜索',
  locationLetter:'按拼音首字母选择',
  rzType:'认证类型',
  qyNameInput:'请输入企业名称',
  qyPicTips:'请上传清晰的营业执照照片，仅用于认证！',
  rzRole:'认证角色',
  rzRoleLegal:'法人',
  rzRoleContact:'联系人',
  rzFrInput:'请输入您的姓名',
  rzContactWay:'联系方式',
  rzContactInput:'请输入联系方式',
  frSfzText:'法人身份证',
  sfzRzText:'请上传清晰的身份证正反面照片，仅用于认证！',
  ContactNameText:'联系人姓名',
  ContactNameInput:'请输入联系人姓名',
  Contactsfz:'联系人身份证',
  applyText:'申请函',
  applyTips:'请上传清晰的申请函（带鲜章）照片，仅用于认证',
  applyDown:'下载申请函模版',
  ResetText:'重置',
  waitText:'资料提交成功，正在审核，请耐心等待',
  waitTips:'审核已通过，感谢您的支持，以下是您的认证信息',
  changeContact:'更换联系人',
  coinRule:'金币规则',
  coinRuleNow:'当前金币',
  changeTime:'变动时间',
  changeType:'收支类型',
  changeOut:'支出',
  changeEnter:'收入',
  changeTypeBd:'变动类型',
  coinChange:'金币变化',
  cancelCollect:'取消收藏',
  runScore:'评分',
  runComment:'评价内容',
  commentMy:'评价我的',
  Mycomment:'我评价的',
  Myapply:'我的回复',
  sjReply:'商家回复',
  feedType:'反馈类型：',
  chooseTextTips:'请选择',
  opinionText:'您的意见：',
  opinionSuccess:'意见提交成功',
  opinionTips:'感谢您的反馈和支持',
  systemText:'系统消息',
  quotation:'报价反馈',
  zbfkText:'中标反馈',
  payText:'支付',
  runHomeText:'跑腿员主页',
  levelText:'级别',
  enterPtText:'入驻平台',
  serviceNumText:'服务客户数',
  DetailJsText:'详情介绍',
  noJsText:'暂无介绍',
  scoreRuleText:'积分规则',
  scoreRuleTips:'当前积分会随着您的会员到期而被清零，请您及时续期会员!',
  closeTips:'关闭提示',
  nowScoreTips:'当前积分',
  Redeempoints:'兑换积分',
  Integralchange:'积分变化',
  Datasetting:'资料设置',
  Accountsecurity:'账号安全',
  Accountpassword:'账号密码',
  AccountTips:'建议您定期更换密码，设置安全性高的密码可以使账号更安全',
  AccountEdit:'修改',
  Accountphone:'账号手机',
  AccountphoneTips:'账号手机可以用于登录账号，重置密码或其他安全验证',
  Bindingwechat:'绑定微信',
  Bound:'已绑定',
  Unbound:'未绑定',
  BindTips:'绑定微信账号，使用微信账号便捷登录',
  Boundjb:'解绑',
  Boundbd:'绑定',
  headPortrait:'头像',
  headEdit:'修改头像',
  nickname:'昵称',
  nicknameTips:'请输入您的昵称',
  cityText:'城市',
  cityTextInput:'请选择所在城市',
  saveText:'保存',
  editMoblieText:'修改手机号',
  AuthenticationText:'验证身份信息',
  AutheNewNumText:'验证新的号码',
  AuthFinshText:'完成号码更换',
  identityText:'为确认身份，我们需验证您的账号手机',
  identityTextTips:'如果您当前的手机号已无法使用请联系客服',
  nowMobileText:'当前账号手机',
  newPhoneInput:'请输入新手机号',
  phoneSuccess:'恭喜您！手机号码修改成功',
  phoneSuccessTips:'请在下次使用新的手机号码进行登录',
  modifyPwd:'修改登录密码',
  oldPwd:'原密码：',
  oldPwdInput:'请输入原密码',
  newPwd:'新密码：',
  newPwdInput:'请输入新密码',
  surePwdInput:'确认密码：',
  surePwdInputTips:'请在再次输入密码',
  pwdTips:'密码长度6~20位，数字、字母、字符至少包含两种',
  cancelTips:'取消',
  signTips:'连续签到可以获得更多积分噢~',
  signTipsText:'已连续签到',
  dayText:'天',
  ljSignText:'立即签到',
  mustText:'为必填项',
  categoryText:'信息类别：',
  categorySecondText:'二级类别：',
  methodText:'排版方式：',
  infoTitleText:'信息标题：',
  infocontentText:'信息内容：',
  picWayText:'图文方式：',
  picUpText:'图片在上',
  fontUpText:'文字在上',
  positionText:'位置：',
  moneyText:'金额：',
  readText:'已阅读并同意',
  agreementText:'发布协议',
  shareSendtText:'分享发布',
  DirectText:'直接发布',
  wxTipsText:'温馨提示：若积分不足, 可以点击分享发布分享内容赚积分哦~',
  rwsendTypeText:'任务类型：',
  ysMoneySendText:'预算金额：',
  ysMoneySendInput:'请输入预算金额',
  endTimeSendText:'截止时间：',
  chooseDateText:'请选择日期',
  sendXqsmText:'需求说明：',
  hotSearchText:'热门搜索',
  searchHistoryText:'搜索历史',
  clearHistoryText:'清除历史',
  noHistoryText:'暂无历史记录',
  addAddressText:'新增地址',
  editAddressText:'修改地址',
  ConsigneeName:'收货人姓名：',
  ConsigneeNameInput:'请输入收货人姓名',
  Consigneemobile :'收货人手机号：',
  ConsigneemobileInput:'请输入收货人手机号',
  LocationText:'所在地区：',
  Detailedaddress:'详细地址：',
  DetailedaddressInput:'请输入详细地址',
  defaultdaddress:'设为默认地址：',
  addressList:'地址列表',
  defaultText:'默认',
  giftText:'礼品详情',
  SupportText:'支持配送',
  SelfText:'可自提',
  DescriptionText:'描述文字',
  GiftInfoText:'礼品简介',
  GiftExchangeText:'礼品兑换',
  Receiving:'收货信息',
  ReceivingWay:'收货方式：',
  mailText:'邮寄',
  selfChooseText:'自提',
  Receivingaddress:'收货地址：',
  selfaddress:'自提地址：',
  chooseaddress:'选择地址',
  MailFreight:'邮寄运费',
  selfTime:'自提时间',
  giftMsg:'礼品信息',
  UnitPrice:'单价',
  quantity:'数量',
  Subtotal:'小计',
  exchangeInfo:'兑换信息',
  Required:'所需积分',
  AccountText:'账户可用积分',
  Exchangerecord:'兑换记录',
  LogisticsText:'物流信息',
  noLogisticsText:'暂无物流信息',
  exchangeTime:'兑换时间',
  exchangeNumber:'兑换数量',
  exchangeDetail:'兑换详情',
  exOneTips:'礼品兑换成功，我们将快递到您的邮寄地址',
  exTwoTips:'礼品兑换成功！请前往自提点核销提取礼品',
  exThreeTips:'礼品已完成提取，感谢您的使用！',
  WriteCode:'核销码',
  Mailingstatus:'邮寄状态',
  ViewLogistics:'查看物流',
  Requiredgold:'所需金币',
  Extractiontime:'提取时间',
  Completiontime:'完成时间',
  downloadClick:'点击下载附件',
  wechartSao:'微信扫一扫分享给好友',

  outTime:'过期时间',


  pushTitle: '推送消息',
  recommendGoods: '推荐商品',
  recommendNews: '推荐资讯',
  recommendStore: '推荐商家',
  recommendNotice: '系统通知',
  notPrompting: '不再提示',
  store: '商家',
  onlineContact: '在线联系',
  storeHome: '商家主页',

  pickingUpAddress: '取货地址：',
  receiptAddress: '收货地址：',
  userGrade: '跑腿员级别：',
  userGradeTips: '更改跑腿级别服务价格将有所改变，如果您要更改请发布前点击这里更改',
  placeholderName: '请输入姓名',
  placeholderMobile: '请输入电话',
  placeholderAddress: '请输入详细地址',
  number: '数量：',
  placeholderNumber: '请输入数量',
  placeholderUnit: '请选择单位',
  kilograms: '公斤数：',
  submitTipsBefore: '本次任务跑腿员服务价格为',
  submitTipsAfter: '金币',

  placeholderContent: '请输入内容',
  sendBtn: '发送',
  overdue: '该商家认证已过期，无法继续沟通',
  deleteDialogue: '删除对话',
  messageCenter: '消息中心',
  releaseMine: '我发布的',
  releaseStore: '商家发布的',
  myOrder: '我的订单',
  placeholderInfo: '请选择发送的信息',
  infoTitle: '发送信息',


  cooperTitle: '商务合作',
  cooperMobile: '联系电话',
  cooperWxName: '微信号',
  cooperEmail: '邮箱',
  cooperOther: '其他联络方式',
  cooperContent: '商务合作需求',
  cooperContentTips: '请输入商务合作需求',
  cooperSuccess: '提交成功',
  cooperSuccessTips: '感谢您的信任和支持，之后会有工作人员与您联系，请耐心等待',

  frozenDetail: '冻结详情',
  frozenNotTips: '您的账号已冻结',
  frozenNotDesc: '不能发布内容，参与活动',
  frozenTips: '您的账号已解封',
  frozenDesc: '可以继续发布内容，参与活动',
  frozenTime: '冻结时间：',
  frozenReason: '冻结原因：',
  frozenApply: '解封申请：',
  frozenApplyTips: '您的解封申请已提交，请等待工作人员审核',
  frozenResult: '处理结果：',
  frozenSupplement: '资料补充：',
  frozenSupplementTips: '您的资料补充已提交，请等待工作人员审核',
  frozenApplyUnblock: '申请解封',
  frozenApplyAgain: '重新申请',
  frozenSupplementInfo: '补充资料',
  frozenTextDescribe: '文字描述：',
  frozenDescPlaceholder: '请输入相关文字描述',
	frozenUpload: '上传图片：',
	
	// 2024-07-16 新增
  confirmOrder: '确认订单',
  confirmOrderSub: '请在10分钟内完成支付',
  consignee: '收货人',
  commodityInformation: '商品信息',
  producName: '商品名称',
  modeOfPayment: '支付方式',
  payByAlipay: '支付宝支付',
  WeChatPay: '微信支付',
  GoldCoinPayment: '金币支付',
  keYong: '可用',
  yuan: '元',
  totalPrices: '总价：',
  AmountToBePaid: '需付金额：',
  payTips: '请选择支付方式',
  topUp: '充值',
  GoldCoinRecharge: '金币充值',
  GoldCoinRechargeAmount: '金币充值金额',
  sellingPrice: '售价',
  amountPayable: '应付金额：',
  goldPayTips: '请选择充值金额',
  reminder: '提示',
	Completedpayment: '已完成支付',
	zfts_tips: '您正在网站外支付,请支付完成后回到当前页确认',
	PurchaseRecord: "购买记录",
	timeBuying: "购买时间",
	paymentAmount: "支付金额",
	purchaseQuantity: "购买数量",
	commodityDetails: "商品详情",
  exOneTipsNew:'购买成功，我们将快递到您的邮寄地址',
	exTwoTipsNew: '购买成功！请前往自提点核销提取商品',
  exThreeTipsNew:'商品已完成提取，感谢您的使用！',
  merchandiseNews:'商品信息',
  year:'年',

}



// WEBPACK FOOTER //
// ./src/common/lang/cn.js